import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {VERSION} from "@/common/version";
import moment from "moment";
import Vuetify from '../plugins/vuetify'
import {
  LOGIN,
  LOGIN_CODE,
  SET_ERRORS,
  LOGOUT,
  REGISTER,
  CHECK_AUTH,
  CHECK_AUTH_NEW_LOGIN,
  CHECK_AUTH_SWITCH_ACCOUNT,
  REGISTER_ORGANIZATION
} from "./actions.type";
import { 
  SET_AUTH,
  SET_ORGANIZATION_AUTH,
  SWITCH_ORGANIZATION_USER_AUTH,
  PURGE_AUTH,
  SET_ERROR,
  SET_USERS,
  SKIP_CHANGE_PASSWORD,
  SKIP_GUIDE,
  UPDATE_GUIDE_STEP,
  UPDATE_STRIPE_STATUS,
  SET_PLAN_STATUS,
  REFRESH
} from "./mutations.type";

const getSetVersion = function() {
    let local_version = JwtService.getVersion();

    if(local_version !== VERSION){
        JwtService.saveVersion(VERSION);
        // window.location = window.location.pathname;
        window.location.reload(true)
        // window.location.reload();
    }
    return VERSION
}

const noData = [null, '', undefined, 'null']

const state = {
  errors: null,
  user: JwtService.getUser(),
  users: JwtService.getUsers(),
  version: null,
  isAuthenticated: !!JwtService.getToken(),
  planStatus: JwtService.getPlanStatus()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  user(state) {
    return state.user;
  },
  userId(state) {
    if (
      state.user &&
      state.user.user_id
    ) {
      return state.user.user_id
    }
    return null
  },
  users(state) {
    return state.users;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  isSubscribed(state) {
    if (
      state.user !== null &&
      state.user.pricing_plan_id !== 0 &&
      state.user.subscription_package !== "Free trial"
    ) {
      if (
        state.user.end_subscription === null ||
        moment(state.user.end_subscription) > moment()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  isTrialActive(state) {
    if (
      state.user !== null &&
      state.user.subscription_package === "Free trial"
    ) {
      if (
        state.user.end_trail === null ||
        moment(state.user.end_trail) > moment()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  endTrial(state) {
    if (state.user !== null && state.user.end_trail !== null) {
      return moment.utc(state.user.end_trail).format("YYYY-MM-DD HH:mm:ss");
    } else {
      return null;
    }
  },
  endSubscription(state) {
    if (state.user !== null && state.user.end_subscription !== null) {
      return moment
        .utc(state.user.end_subscription)
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return null;
    }
  },
  subscriptionExpired() {
    let today = new Date();
    if (state.user !== null && state.user.endSubscription !== null) {
      if (moment(today) > moment.utc(state.user.end_subscription)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  trialExpired() {
    let today = new Date();
    if (state.user !== null && state.user.endTrial !== null) {
      if (moment(today) > moment.utc(state.user.end_trail)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  subscriptionPackage() {
    if (state.user !== null && state.user.subscription_package !== null) {
      return state.user.subscription_package;
    } else {
      return null;
    }
  },
  organizationId() {
    if (state.user !== null) {
      return state.user.organization_id;
    } else {
      return null;
    }
  },
  firstLogin() {
    // return false
    if (state.user !== null && state.user.change_password !== null) {
      return state.user.change_password === 1;
    } else {
      return false;
    }
  },
  stripeCompleted() {
    if (state.user !== null && state.user.status) {
      if (state.user.status === "active") {
        return true;
      } else if (state.user.status === "in_progress") {
        return false;
      }
    } else {
      return false;
    }
  },
  permissions() {
    let out = [
      'settings',
      'dormant_clients',
      'directory_listing',
    ]
    if (state.user !== null && state.user.permissions) {
      let permissions = JSON.parse(state.user.permissions)
      if ( typeof permissions === 'object' ) {
        if (!Array.isArray(permissions)) {
          permissions = Object.values(permissions)
        }
        return [...permissions, ...out]
      } else {
        return out;
      }
    } else {
      return out;
    }
  },
  payoutsDisabled() {
    if (
      state.user !== null &&
      state.user.status &&
      state.user.payouts_enabled !== undefined
    ) {
      return (
        state.user.status === "active" &&
        Number(state.user.payouts_enabled) === 0
      );
    } else {
      return false;
    }
  },
  chargesDisabled() {
    if (
      state.user !== null &&
      state.user.status &&
      state.user.charges_enabled !== undefined
    ) {
      return (
        state.user.status === "active" &&
        Number(state.user.charges_enabled) === 0
      );
    } else {
      return false;
    }
  },
  planStatus(state) {
    return state.planStatus;
  },
  userSettings() {
    return state.user.user_settings
  },
  onboardingGuide() {
    if (
      state.user &&
      state.user.user_settings &&
      state.user.user_settings.some(i => i.key === 'onboarding_guide')
    ) {
      return state.user.user_settings.find(i => i.key === 'onboarding_guide').value.split(',')
    }
    return null
  },
  paymentProcessor() {
    if(
      state.user !== null &&
      state.user.card_connect_site !== undefined &&
      state.user.card_connect_site !== null
    ) {
      return 'card_connect'
    } else {
      return 'stripe'
    }
  },
  belongsToFranchise() {
    if (
      !noData.includes(state.user) &&
      !noData.includes(state.user.belongs_to_franchise)
    ) {
      return state.user.belongs_to_franchise;
    } else {
      return null;
    }
  },
  belongsToFranchiseName() {
    if (
      !noData.includes(state.user) &&
      !noData.includes(state.user.belongs_to_franchise_name)
    ) {
      return state.user.belongs_to_franchise_name;
    } else {
      return null;
    }
  },
  getContrast: (state) => (hexcolor) => {
    let hc = hexcolor

    if (hc.slice(0, 1) === '#') {
      hc = hc.slice(1);
    }

    if (hc.length === 3) {
      hc = hc.split('').map(function (hex) {
        return hex + hex;
        }).join('');
    }

    var r = parseInt(hc.substr(0,2),16);
    var g = parseInt(hc.substr(2,2),16);
    var b = parseInt(hc.substr(4,2),16);

    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000

    return (yiq >= 128) ? 'black' : 'white';
  },
  getContrast: (state) => (hexcolor) => {
    let hc = hexcolor

    if (hc.slice(0, 1) === '#') {
      hc = hc.slice(1);
    }

    if (hc.length === 3) {
      hc = hc.split('').map(function (hex) {
        return hex + hex;
        }).join('');
    }

    var r = parseInt(hc.substr(0,2),16);
    var g = parseInt(hc.substr(2,2),16);
    var b = parseInt(hc.substr(4,2),16);

    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000

    return (yiq >= 128) ? 'black' : 'white';
  },
  getTwoColorContrast: () => (color1 = '#ffffff', color2 = '#ffffff', returnRatio = false) => {
    const formatColor = hexcolor => {
      let hc = hexcolor

      if (hc.slice(0, 1) === '#') {
        hc = hc.slice(1);
      }
  
      if (hc.length === 3) {
        hc = hc.split('').map(function (hex) {
          return hex + hex;
          }).join('');
      }
  
      var r = parseInt(hc.substr(0,2),16);
      var g = parseInt(hc.substr(2,2),16);
      var b = parseInt(hc.substr(4,2),16);

      return [r, g, b]
    }

    let c1 = formatColor(color1)
    let c2 = formatColor(color2)

    const RED = 0.2126;
    const GREEN = 0.7152;
    const BLUE = 0.0722;

    const GAMMA = 2.4;

    const luminance = (r, g, b) => {
      var a = [r, g, b].map((v) => {
        v /= 255;
        return v <= 0.03928
          ? v / 12.92
          : Math.pow((v + 0.055) / 1.055, GAMMA);
      });
      return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
    }

    const contrast = (rgb1, rgb2) => {
      var lum1 = luminance(...rgb1);
      var lum2 = luminance(...rgb2);
      var brightest = Math.max(lum1, lum2);
      var darkest = Math.min(lum1, lum2);
      return (brightest + 0.05) / (darkest + 0.05);
    }
    if (returnRatio) {
      return contrast(c1, c2)
    }
    return contrast(c1, c2) >= 3
  },
  shadeColor: () => (color, percent) => {
    const formatColor = hexcolor => {
      let hc = hexcolor

      if (hc.slice(0, 1) === '#') {
        hc = hc.slice(1);
      }
  
      if (hc.length === 3) {
        hc = hc.split('').map(function (hex) {
          return hex + hex;
          }).join('');
      }
  
      var r = parseInt(hc.substr(0,2),16);
      var g = parseInt(hc.substr(2,2),16);
      var b = parseInt(hc.substr(4,2),16);

      return [r, g, b]
    }
    let R = formatColor(color)[0];
    let G = formatColor(color)[1];
    let B = formatColor(color)[2];

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R<255)?R:255;  
    G = (G<255)?G:255;  
    B = (B<255)?B:255;  

    R = Math.round(R)
    G = Math.round(G)
    B = Math.round(B)

    var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
    var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
    var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

    return "#"+RR+GG+BB;
  },
  correctColor: (state, getters) => (color) => {
    let out = color
    while (!getters.getTwoColorContrast(out)) {
      out = getters.shadeColor(out, -1)
    }
    return out
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("auth/login", credentials)
        .then(({ data }) => {
            if(data.token){
              if(Number(data.user.two_factor) !== 1) {
                context.commit(SET_AUTH, data);
                context.dispatch('setOrganizationBranding')
              }
              resolve(data);
            }else{
                context.commit(SET_ERROR, data);
                reject(data);
            }
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [LOGIN_CODE](context, code) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader(code.token)
      delete code.token
      ApiService.post("validate_two_factor", code)
        .then(({ data }) => {
            // if(data.token){
            //   context.commit(SET_AUTH, data);
            //   resolve(data);
            // }else{
            //   ApiService.setHeader()
            //   context.commit(SET_ERROR, data);
            //   reject(data);
            // }
            resolve(data);
        })
        .catch(({ response }) => {
          ApiService.setHeader()
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [REGISTER_ORGANIZATION](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("register_organization/step1", credentials)
        .then(({ data }) => {
          if (data.token && data.user) {
            // Second step completed
            context.commit(SET_AUTH, data);
            resolve(data);
          } else if (data.token && !data.user) {
            // Second step not completed
            context.commit(SET_ORGANIZATION_AUTH, data);
            resolve(data);
          } else {
            // Organization exists but cridentials are not correct
            context.commit(SET_ERROR, data);
            reject(data)
          }
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response)
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
    context.dispatch('setOrganizationBranding');
  },
  [SET_ERRORS](context, errors) {
    context.commit(SET_ERROR, errors);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("users", { user: credentials })
        .then(({ data }) => {
          context.commit(SET_AUTH, data.user);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [CHECK_AUTH](context, token) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken() || token) {
        if (token) {
          ApiService.setHeader(token);
        } else {
          ApiService.setHeader();
        }
          ApiService.get("/auth/employee_user")
            .then(({ data }) => {
              context.commit(SET_AUTH, data);
              context.dispatch('setOrganizationBranding')
              resolve(data);
            })
            .catch(({ response }) => {
              context.commit(SET_ERROR, response.data.errors);
              context.dispatch('setOrganizationBranding')
              reject(response);
            })
      } else {
        context.commit(PURGE_AUTH);
        reject();
      }
    });
  },
  [CHECK_AUTH_NEW_LOGIN](context, token) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken() || token) {
        if (token) {
          ApiService.setHeader(token);
        } else {
          ApiService.setHeader();
        }
          ApiService.getNewLogin("/auth/employee_user")
            .then(({ data }) => {
              context.commit(SET_AUTH, data);
              context.dispatch('setOrganizationBranding')
              resolve(data);
            })
            .catch(({ response }) => {
              context.commit(SET_ERROR, response.data.errors);
              context.dispatch('setOrganizationBranding')
              reject(response);
            })
      } else {
        context.commit(PURGE_AUTH);
        reject();
      }
    });
  },
  [CHECK_AUTH_SWITCH_ACCOUNT](context, payload) {
    return new Promise((resolve, reject) => {
      if (payload.token && payload.user && payload.user.organization_id) {
        ApiService.setHeader(payload.token);
        ApiService.getNewLogin("/auth/employee_user", { organization_id: payload.user.organization_id })
          .then(({ data }) => {
            context.commit(SET_AUTH, data);
            context.dispatch('setOrganizationBranding')
            resolve(data);
          })
          .catch(({ response }) => {
            if (response && response.data && response.data.errors) {
              context.commit(SET_ERROR, response.data.errors);
            }
            context.dispatch('setOrganizationBranding')
            reject(response);
          })
      } else {
        context.commit(PURGE_AUTH);
        reject();
      }
    });
  },
  setOrganizationBranding (context) {
    let data = {
      header: '#212121'
    }
    if (
      !noData.includes(context) &&
      !noData.includes(context.getters) &&
      !noData.includes(context.getters.user)
    ) {
      if (!noData.includes(context.getters.user.franchise_color)) {
        data.header = context.getters.user.franchise_color
      }
    }
    context.commit('setOrganizationBranding', data)
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = { ...user.user };
    state.errors = null;
    JwtService.saveToken(user.token);
    JwtService.saveOrganizationId(user.user.organization_id);
    JwtService.saveUser(user.user);

    // remove items with same user_id from users
    if (
      state &&
      state.users &&
      Array.isArray(state.users) &&
      state.users.some(i => i.user_id === state.user.user_id)
    ) {
      let filteredUsers = state.users.filter(i => i.user_id !== state.user.user_id)
      filteredUsers.unshift({ ...state.user, token: user.token })
      state.users = filteredUsers
      JwtService.saveUsers(filteredUsers)
    }
    // If user have multiple organizations with same account
    if(
      user.user &&
      user.user.organizations &&
      Array.isArray(user.user.organizations) &&
      user.user.organizations.some(i => i.organization_id !== user.user.organization_id)
    ) {
      let organizations = user.user.organizations.map(i => {
        if (i.organization_id === user.user.organization_id) {
          return { ...user.user, token: user.token }
        } else {
          return {
            full_name: `${i.first_name} ${i.last_name}`,
            organization_name: i.name,
            organization_id: i.organization_id,
            token: user.token,
            user_id: user.user.user_id
          }
        }
      })
      if (
        state.users &&
        Array.isArray(state.users) &&
        state.users.length
      ) {
        let newUsers = [...state.users]
        organizations.forEach(i => {
          if(!newUsers.some(u => u.organization_id === i.organization_id && u.user_id === i.user_id)) {
            newUsers.push(i)
          }
        })
        state.users = newUsers
        JwtService.saveUsers(newUsers);
      } else {
        state.users = organizations
        JwtService.saveUsers(organizations);
      }
    }
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.users = null;
    state.errors = null;
    JwtService.destroyToken();
    JwtService.destroyOrganizationId();
    JwtService.destroyOrganizationToken();
    JwtService.destroyUser();
    JwtService.destroyUsers();
  },
  [SET_ORGANIZATION_AUTH](state, user) {
    state.isAuthenticated = false;
    state.user = user;
    state.errors = {};
    JwtService.saveOrganizationToken(state.user.token);
  },
  [SWITCH_ORGANIZATION_USER_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    let token = JwtService.getOrganizationToken();
    JwtService.saveToken(token);
    JwtService.destroyOrganizationToken();
  },
  [SET_USERS](state, users) {
    state.users = users
    JwtService.saveUsers(users);
  }, 
  [SKIP_CHANGE_PASSWORD](state) {
    let user = state.user;
    user.change_password = 0;
    JwtService.saveUser(user);
  },
  [SKIP_GUIDE](state) {
    let user = state.user;
    user.show_guide = 0;
    JwtService.saveUser(user);
  },
  [UPDATE_GUIDE_STEP](state, step) {
    let user = state.user;
    user.step_guide = step;
    JwtService.saveUser(user);
  },
  [UPDATE_STRIPE_STATUS](state, data) {
    let user = state.user;
    user.payouts_enabled = Number(data.payouts_enabled);
    user.charges_enabled = Number(data.charges_enabled);
    JwtService.saveUser(user);
  },
  [SET_PLAN_STATUS](state, data) {
    state.planStatus = data
    JwtService.savePlanStatus(data);
  },
  [REFRESH](state) {
    state.version = getSetVersion();
  },
  setOrganizationBranding (state, data) {
    Vuetify.framework.theme.themes.light.header = data.header
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
